import isFeatureAvailable from './is-feature-available';

export default {
  isFeatureAvailable,
};
